import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, P } from '@a-type/ui';
import { apps } from '@biscuits/apps';
import { useHasServerAccess } from '../hooks/graphql.js';
import { useLocalStorage } from '../hooks/useStorage.js';
import { useAppId } from './Context.js';
import cls from './InfrequentSubscriptionHint.module.css';
import { PromoteSubscriptionButton } from './PromoteSubscriptionButton.js';
const now = Date.now();
export function InfrequentSubscriptionHint() {
    var _a, _b;
    const appId = useAppId();
    const appName = (_b = (_a = apps.find((app) => app.id === appId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'this app';
    const isSubscribed = useHasServerAccess();
    const [startCountingAt] = useLocalStorage('first-time-seen', now, true);
    // if this component mounts and the user has been using the app for more than 30 days, show the hint
    // once. after dismissal, the time to show again is upped to 60 days.
    const [dismissedAt, setDismissedAt] = useLocalStorage('subscription-hint-dismissed-at', 0);
    const daysSinceFirstSeen = (now - startCountingAt) / 1000 / 60 / 60 / 24;
    const daysSinceDismissed = (now - dismissedAt) / 1000 / 60 / 60 / 24;
    // strict check important. undefined = not loaded
    if (isSubscribed !== false) {
        return null;
    }
    if (daysSinceDismissed > 60 && daysSinceFirstSeen > 30) {
        return (_jsxs("div", { className: cls.root, children: [_jsxs(P, { children: ["Enjoying ", appName, "? A subscription unlocks device sync and more"] }), _jsxs("div", { className: cls.actions, children: [_jsx(Button, { emphasis: "ghost", onClick: () => setDismissedAt(Date.now()), children: "Dismiss" }), _jsx(PromoteSubscriptionButton, { children: "Learn more" })] })] }));
    }
    return null;
}
//# sourceMappingURL=InfrequentSubscriptionHint.js.map